import React, { useState } from 'react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const PudorisDomu = () => {

    Fancybox.bind('[data-fancybox="gallery"]', {});

    const [activeTab, setActiveTab] = useState("01");

    const floors = {
        "01": "./images/floor-plan/01.png",
        "02": "./images/floor-plan/02.jpg",
        "03": "./images/floor-plan/03.jpg",
        "04": "./images/floor-plan/04.jpg",
        "05": "./images/floor-plan/05.jpg"
    };

    return (
        <div id="content" className="pudoris-domu">
            <div className="container">
                <h1>Půdorys domu</h1>
            </div>
            <div className="nav-menu">
                <div className="container">
                    <ul>
                        {Object.keys(floors).map(tab => (
                            <li key={tab} onClick={() => setActiveTab(tab)} className={activeTab === tab ? "active" : ""}>
                                {tab === "01" && "1. NP"}
                                {tab === "02" && "Čelní pohled"}
                                {tab === "03" && "Boční pohled"}
                                {tab === "04" && "Zadní pohled"}
                                {tab === "05" && "Řez domem"}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="preview">
                <p>Dispozice obytné části domu lze po domluvě přizpůsobit</p>
                <img src={floors[activeTab]} alt="Půdorys" data-fancybox="gallery" loading="lazy" />
            </div>
        </div>
    )
}

export default PudorisDomu;